import { render, staticRenderFns } from "./SelfPublishingFlowQuote.vue?vue&type=template&id=65ce3320&scoped=true&"
import script from "./SelfPublishingFlowQuote.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlowQuote.vue?vue&type=script&lang=js&"
import style0 from "./SelfPublishingFlowQuote.vue?vue&type=style&index=0&id=65ce3320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce3320",
  null
  
)

export default component.exports